import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OverlayService } from 'shared/services/overlay/overlay.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ThemeService } from 'shared/services/parameter/theme.service';
import { ParameterModel } from 'shared/services/parameter/parameter.service';
import { Observable, combineLatest, map } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectIsConnected } from 'store/account/account.selectors';
import { selectCompanyPageLoading } from 'store/company/company.selectors';

@Component({
  selector: 'app-support-dialog',
  templateUrl: './support-dialog.component.html',
  styleUrls: ['./support-dialog.component.scss'],
})
export class SupportDialogComponent implements OnInit {
  isOpen = true;
  loading = false;

  parameter$: Observable<ParameterModel>;
  iFrame$: Observable<SafeHtml>;
  isOpen$: Observable<boolean>;

  isConnected: boolean;

  telInfo: string | null;
  mailInfo: string | null;
  comemrcialName: string | null;

  constructor(
    private overlayService: OverlayService,
    private sanitizer: DomSanitizer,
    private themeService: ThemeService,
    private store: Store,
  ) {}

  ngOnInit(): void {
    this.parameter$ = this.themeService.parameter$;
    this.store.select(selectIsConnected).subscribe(isConnected => {
      this.isConnected = isConnected;
    });
    if(this.isConnected){
      this.store.select(selectCompanyPageLoading).subscribe(companyPage => {
        if(companyPage?.commercials?.length > 0){
            const commercial = companyPage.commercials[0];
            console.log(commercial);
            
            this.telInfo = commercial.phone1 === 'false' ? null : commercial.phone1;
            this.mailInfo = commercial.mail === 'false' ? null : commercial.mail;
            var firstName = commercial.name === 'false' ? null : commercial.name;
            var lastname = commercial.lastname === 'false' ? null : commercial.lastname;
            this.comemrcialName = (firstName || '') + ' ' + (lastname || '');
        }else{
            this.parameter$.subscribe(parameter => {
              this.telInfo = parameter.phoneNumber;
              this.mailInfo = parameter.supportEmail;
              this.comemrcialName = parameter.commercialName;
            });
        }
      })
    }else{
            this.parameter$.subscribe(parameter => {
              this.telInfo = parameter.phoneNumber;
              this.mailInfo = parameter.supportEmail;
              this.comemrcialName = parameter.commercialName;
            });
    }

    


    this.iFrame$ = this.parameter$.pipe(
      map(param => param ? this.sanitizer.bypassSecurityTrustHtml(param.htmlMapEmbedCode) : null)
    );

    this.isOpen$ = this.parameter$.pipe(
      map(param => {
        if (!param) return false;
        const hour = new Date().getHours();
        
        const closing = parseInt(param.closingTime.split(':')[0], 10);
        const opening = parseInt(param.openingTime.split(':')[0], 10);

        if (isNaN(closing)) return false;
        return hour > opening && hour < closing;
      })
    );
  }

  closeDialog() {
    this.overlayService.closeDilog();
  }

  sendEmail() {
    window.location.href = 'mailto:' + this.mailInfo;
    this.closeDialog();
  }

  call() {
    window.location.href = 'tel:' + this.telInfo;
    this.closeDialog();
  }
}
